import { ReactNode } from 'react';
import buttonStyle from './IButton.module.scss';

interface IProps {
    title: string;
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    variant?: 'primary' | 'ghost' | 'subtle';
    size?: 'md' | 'lg';
    fullWidth?: boolean;
    icon?: ReactNode;
    iconPosition?: 'start' | 'end';
    className?: string;
    ariaLabel?: string;
}

const IButton = (props: IProps) => {
    const {
        title,
        onClick,
        type = 'button',
        disabled,
        variant = 'primary',
        size = 'md',
        fullWidth,
        icon,
        iconPosition = 'end',
        className = '',
        ariaLabel,
    } = props;

    const classes = [
        buttonStyle.button,
        buttonStyle[variant],
        buttonStyle[size],
        fullWidth ? buttonStyle.fullWidth : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <button className={classes} onClick={onClick} type={type} disabled={disabled} aria-label={ariaLabel}>
            {icon && iconPosition === 'start' && <span className={buttonStyle.icon}>{icon}</span>}
            <span>{title}</span>
            {icon && iconPosition === 'end' && <span className={buttonStyle.icon}>{icon}</span>}
        </button>
    );
};

export default IButton;
